/**
 * @file index.tsx
 *
 * @fileoverview Renders the ClickableChip component.
 */
import React from 'react';
import { Chip, ChipProps } from '~/vcl/atoms/01-forms/08-chip';
import styles from './clickable-chip.module.scss';

interface ClickableChipProps extends ChipProps {
  /**
   * Field that will get populated with the term value on click.
   */
  fieldName: string;
  /**
   * The name of the chip.
   */
  chipName: string;
  /**
   * Callback for when clicking the component.
   */
  onClick?(chipId: string, fieldName: string, chipName: string): void;
}

export function ClickableChip({
  onClick,
  fieldName,
  chipName,
  ...rest
}: ClickableChipProps) {
  const handleClick = () => {
    if (onClick) {
      onClick(fieldName, rest.chipId, chipName);
    }
  };

  return (
    <div className={styles.clickableChip} onClick={handleClick}>
      <Chip {...rest} />
    </div>
  );
}

export default ClickableChip;
